import { useEffect, useRef } from 'react';

// The app scrolls inside #root (html/body are fixed, see index.css), so
// swapping the page component doesn't reset the scroll position by itself.

export const getScrollRoot = () => document.getElementById('root');

export const scrollRootTo = (top = 0) => {
  const root = getScrollRoot();
  if (root) root.scrollTo({ top, left: 0, behavior: 'auto' });
};

/** Scroll to the top whenever any of `deps` changes (skips the initial mount). */
export const useScrollToTop = (deps) => {
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    scrollRootTo(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
